import { WINDOW_KEY } from './constants';

const push = data => {
    window[WINDOW_KEY] = window[WINDOW_KEY] || [];
    window[WINDOW_KEY].push(data);
};

export default push;

const wrap = base => data => {
    push(Object.assign({}, base, data));
};

export const toast = wrap({ name: 'toast' });
export const trackjs = wrap({ name: 'trackjs' });
export const broadcast = wrap({ name: 'broadcast' });



// WEBPACK FOOTER //
// lib/client.js